module.exports = __webpack_public_path__ + "static/media/chart-24k-v2--black.41013b19.svg";